import PropTypes from 'prop-types';
import { CSVDownload } from 'react-csv';

import { get } from 'lodash';

import { COLUMNS } from './SweepWinnerTable';

const propTypes = {
  data: PropTypes.array,
};

export default function ReportCsv({ data }) {
  const sweepWinner = [];
  const header = [];
  sweepWinner.push(header);

  data.forEach((row, idx) => {
    const line = COLUMNS.map(({ dataField, formatter, text }) => {
      if (idx === 0) {
        header.push(text);
      }

      const cell = get(row, dataField);

      if (formatter) {
        return formatter(cell, row, null, true);
      }
      return cell;
    })

    sweepWinner.push(line);
  })

  return <CSVDownload data={sweepWinner} target="_blank" />
}

ReportCsv.propTypes = propTypes;
